import ThrowsValidationError from "common/http/throwsValidationError";
import CommodityLimit from "./commodityLimit";
import AdminHttpService from "admin/common/adminHttpService";

class MerchantRiskService extends AdminHttpService {
    async listCommodityLimits(merchantId: string): Promise<CommodityLimit[]> {
        const response = await this.getClient().get<CommodityLimit[]>(`/settings/v1/merchants/${merchantId}/commodity-limits`);
        return response.data;
    }
    
    @ThrowsValidationError()
    async updateLimit(merchantId: string, limit: CommodityLimit): Promise<any> {
        const response = await this.getClient().put<CommodityLimit[]>(
            `/settings/v1/merchants/${merchantId}/commodity-limits/${limit.commodity.id}`, 
            {
                dayPurchaseLimit: limit.dayPurchaseLimit,
                daySaleLimit: limit.daySaleLimit,
                nightPurchaseLimit: limit.nightPurchaseLimit,
                nightSaleLimit: limit.nightSaleLimit,
                autoPositionDayPurchaseLimit: limit.autoPositionDayPurchaseLimit,
                autoPositionDaySaleLimit: limit.autoPositionDaySaleLimit,
                autoPositionNightPurchaseLimit: limit.autoPositionNightPurchaseLimit,
                autoPositionNightSaleLimit: limit.autoPositionNightSaleLimit,
                autoPositionNightMaxFrequencyMilliseconds: limit.autoPositionNightMaxFrequencyMilliseconds
            }
        );
        return response.data;
    }
}

const merchantRiskService = new MerchantRiskService();
export default merchantRiskService;